import React, { useRef } from 'react';
import { Box } from '@mui/material';

export default function BBFHeroBanner() {
  const iframeRef = useRef(null);

  const videoId = 'M2ZSwM-8fBs'; // Your YouTube video ID

  return (
    <Box sx={{ position: 'relative', width: '100%', backgroundColor: '#000' }}>
      <iframe
        ref={iframeRef}
        src={`https://www.youtube.com/embed/${videoId}?autoplay=1&mute=1&loop=1&playlist=${videoId}&modestbranding=1&rel=0&showinfo=0&controls=0&fs=0`}
        title="Site of a Miracle"
        style={{ width: '100%', height: '500px', border: 'none' }}
        allow="autoplay; fullscreen"
      />
    </Box>
  );
}
